/*** IMPORTS FROM imports-loader ***/
var define = false;

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

